module.exports = __webpack_public_path__ + "static/img/shpinpng7338fe2.png";